import { NgModule } from '@angular/core';
import { Ga4GgCartAddEntrySuccessEventBuilder } from './ga4-gg-cart-add-entry-success-event.builder';

@NgModule({})
export class Ga4GgCartAddEntrySuccessEventModule {
  constructor(_ga4GgCartAddEntrySuccessEventBuilder: Ga4GgCartAddEntrySuccessEventBuilder) {}
}
